// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

import { getLocationItems } from '../../utils/location';

interface DropdownProps {
    location: string;
    countryCode?: string;
    handleDropdown: (e: Event) => void;
}

const LocationDropdown: FunctionalComponent<DropdownProps> = ({ location, countryCode, handleDropdown }) => {
    const locationItems = getLocationItems(location, countryCode);
    const isNotExistingLocation = !locationItems.some(item => item.value === location);

    return (
        <div class="dropdown-container">
            <select
                id="bam-dropdown"
                class={`dropdown dropdown-font ${isNotExistingLocation ? 'dropdown-default-font' : ''}`}
                onInput={handleDropdown}
            >
                {isNotExistingLocation ? (
                    <option selected value="">
                        Select a location
                    </option>
                ) : (
                    <option value="">Select a location</option>
                )}
                {locationItems.map(item => {
                    return location === item.value ? (
                        <option selected value={item.value}>
                            {item.display}
                        </option>
                    ) : (
                        <option value={item.value}>{item.display}</option>
                    );
                })}
            </select>
            <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                class="dropdown-arrow"
                fill="#A4A4AA"
                stroke="#A4A4AA"
                stroke-width="0"
            >
                <title>Right Arrow</title>
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
        </div>
    );
};

export default LocationDropdown;
